import { Container } from "@mui/material";
import { FC } from "react";
import "./municipality-home-bar.css";
import { MunicipalityChangeCityButton } from "./municipality-change-city-button";
import BreadCrumbGeneric from "../../components/breadcrumb/breadcrumb_generic";

type MunicipalityHomeBarProps = {
  municipalityName?: string;
};

export const MunicipalityHomeBar: FC<MunicipalityHomeBarProps> = ({
  municipalityName,
}) => {
  if (!municipalityName) {
    return null;
  }

  return (
    <div
      id="municipality-home-bar"
      data-testid="municipality-home-bar"
      className="xvia-municipality-home-bar"
    >
      <Container className="xvia-municipality-home-bar__content">
        <span className="xvia-municipality-home-bar__breadcrumb">
          <BreadCrumbGeneric
            variant={municipalityName ? "municipios" : "default"}
            props={[
              { name: "Municípios", link: "/app/catalog/list/municipios" },
              {
                name: municipalityName,
              },
            ]}
          />
        </span>
        <MunicipalityChangeCityButton className="xvia-municipality-home-bar__button" />
      </Container>
    </div>
  );
};
